import React, { useState } from "react";
import Sidebar from "../components/Sidebar/AdminSidebar";
import AdminRoutes from "../routes/AdminRoutes";
import { Route, Routes } from "react-router-dom";
import Header from "../components/Header";
import styles from './index.module.css';
import NotFound from "../components/NotFound";
import Footer from "../components/Footers";
import { useSelector } from "react-redux";

const UserLayout = () => {
    const entityVersion = useSelector(
    (state) => state.auth.entityVersion
);

    const [isSidebarOpen, setSidebarOpen] = useState(false);

    const toggleSidebar = () => setSidebarOpen(!isSidebarOpen);
    const closeSidebar = () => setSidebarOpen(false);

    return (
        <div key={entityVersion} className={styles.appContainer}>
            <Sidebar  isSidebarOpen={isSidebarOpen} closeSidebar={closeSidebar}/>
            <div className={styles.main}>                
            <Header toggleSidebar={toggleSidebar}/>
            <div className={styles.content}>
                <Routes>
                    {AdminRoutes.map((prop, key) => (
                        <Route path={prop.path} element={prop.element} key={key} />
                    ))}
                    <Route path="*" element={<div><NotFound/></div>} />
                </Routes>
                <Footer/>        
            </div>    
            </div>
        </div>
    );
};

export default UserLayout;
